// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { BannersService } from '@app/core/services/banners/banners.service';
import { copyToClipboard } from '@app/core/models/helpers';
import { IBannerConfigData } from '@app/core/services/banners/banners.service.types';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { NotificationTypes } from '@app/core/services/global-notifications/global-notifications.model';

@Component({
  selector: 'app-banner-code',
  templateUrl: './banner-code.component.html',
  styleUrls: ['./banner-code.component.scss']
})
export class BannerCodeComponent implements OnInit {
  @Input() bannerConfigurationData?: IBannerConfigData;

  public isLoaded = false;
  public bannerCode = '';

  constructor(
    private globalNotificationsService: GlobalNotificationsService,
    private bannerService: BannersService
  ) {}

  ngOnInit(): void {
    this.bannerService
      .getBannerScript(
        this.bannerConfigurationData?.bannerConfigID || 0,
        this.bannerConfigurationData?.domainID || 0,
        this.bannerConfigurationData?.programID || 0
      )
      .subscribe(
        res => {
          this.bannerCode = res.data?.script || '';
          this.isLoaded = true;
        },
        () => {
          this.showNotification('error_occured', NotificationTypes[1]);
        }
      );
  }

  async copyInputMessage(): Promise<void> {
    const { success, message } = await copyToClipboard(this.bannerCode, {
      successMessage: 'view_translations.code_copied'
    });

    this.showNotification(message, NotificationTypes[success ? 3 : 1]);
  }

  private showNotification(message: string, type: (typeof NotificationTypes)[number], translate: boolean = true): void {
    this.globalNotificationsService.show({
      message: translate && !message.includes('view_translations.') ? `view_translations.${message}` : message,
      type,
      translate,
      isPersistent: false,
      id: ''
    });
  }
}
